export function hasIpAddress(ipAddress?: string | null): boolean {
  return !!ipAddress?.trim();
}
